
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesGrid from './components/ServicesGrid';
import ProcessSection from './components/ProcessSection';
import CTASection from './components/CTASection';

const Services = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-black relative">
      <Header />
      
      <div className="relative">
        <HeroSection />
        <ServicesGrid />
        <ProcessSection />
        <CTASection />
      </div>
      
      <Footer />
    </div>
  );
};

export default Services;
